import React, {Component} from 'react'
import {TabContent, TabPane, Nav, NavItem, NavLink, Row, Col} from 'reactstrap'

import {Query} from 'react-apollo'
import classnames from 'classnames'

import CreateUserForm from "./CreateUserForm"

import query from '../../../queries/server/user'


export default class CreateUser extends Component {

    state = {
        activeTab: 'details'
    }

    render() {


        return (
            <div className="m-4">

                <Nav tabs>
                    <NavItem>
                        <NavLink
                            className={classnames({active: this.state.activeTab === 'details'})}
                            onClick={() => {
                                this.toggle('details');
                            }}
                        >
                            Details
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            className={classnames({active: this.state.activeTab === 'permissions'})}
                            onClick={() => {
                                this.toggle('permissions');
                            }}
                            disabled
                        >
                            Permissions
                        </NavLink>
                    </NavItem>
                </Nav>

                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId="details">
                        <Row>
                            <Col sm="12 mt-4">
                                <CreateUserForm/>
                            </Col>
                        </Row>
                    </TabPane>
                </TabContent>

            </div>
        )


    }

}